export default __webpack_public_path__ + "static/media/portal-clip1.541f9058.png";